<template>
    <div>
        <div :class="{'row':vertical}">
            <label class="col-form-label" :class="{'col-lg-6':vertical, 'padding-top-zero':!vertical}" v-if="label">{{label}}</label>
            <div :class="{'col-lg-6':vertical}"  style="display: flex">
                <div></div>
                <div class="ml-auto">
                    <div class="switches">
                        <div class="toggle" :class=[this.state_class] @click.self="onClick">
                            <div class="draggable" @mousedown.prevent="dragStart" :style="style"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name:'BasicSwitch',
        props: {
            vertical: {
                type: Boolean,
                default: false,
            },
            value: {
                type: String,
                default: 'Y'
            },
            label: {
                type: String
            }
        },
        data() {
            return {
                width: 100,
                state: false,
                pressed: 0,
                position: 0
            }
        },
        mounted() {
            this.toggle(this.value === 'Y')
        },
        computed: {
            style() {
                return {
                    transform: `translateX(${this.pos_percentage})`
                }
            },
            pos_percentage() {
                return `${this.position / this.width * 100}%`
            },
            state_class() {
                if (this.state) {
                    return 'active'
                } else {
                    return ''
                }
            }
        },
        watch: {
            'position':function() {
                this.state = this.position >= 50
            },
            'value':function(val) {
                this.position = (val === 'Y' ? 100 : 0)
            }
        },
        methods: {
            onClick() {
                this.toggle(!this.state)
                this.emit()
            },
            toggle(state) {
                this.state = state
                this.position = !state
                    ? 0
                    : 100
            },
            dragging(e) {
                const pos = e.clientX - this.$el.offsetLeft
                const percent = pos / this.width * 100
                this.position = percent <= 0
                    ? 0
                    : percent >= 100
                        ? 100
                        : percent
            },
            dragStart(e) {
                this.startTimer()
                window.addEventListener('mousemove', this.dragging)
                window.addEventListener('mouseup', this.dragStop)
            },
            dragStop() {
                window.removeEventListener('mousemove', this.dragging)
                window.removeEventListener('mouseup', this.dragStop)
                this.resolvePosition()
                clearInterval(this.$options.interval)
                if (this.pressed < 30) {
                    this.toggle(!this.state)
                }
                this.pressed = 0
                this.emit()
            },
            startTimer() {
                this.$options.interval = setInterval(() => {
                    this.pressed++
                }, 1)
            },
            resolvePosition() {
                this.position = this.state
                    ? 100
                    : 0
            },
            emit() {
                this.$emit('input', this.state? 'Y':'N')
            }
        }
    }
</script>

<style scoped>
    .padding-top-zero {
        padding-top: 0px !important;
    }
    .toggle {
        width: 61px;
        height: 32px;
        background: #fff;
        border: 2px solid #ddd;
        border-radius: 200px;
        transition: background 0.6s;
    }
    .toggle .draggable {
        width: 28px;
        height: 27px;
        background: #fff;
        border-radius: 100%;
        box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.6);
        -webkit-transform: translateX(0%);
        transform: translateX(0%);
        transition: -webkit-transform 0.05s ease-in-out;
    }
    .toggle.active {
        background: #04C73C;
        transition: background 0.6s;
    }
    /*.switches {*/
    /*    margin-right: 30px*/
    /*}*/
</style>
